import { gql } from "@/services/httpAdapter";

export const updatePdfAvailability = gql`
	subscription onUpdatePdfAvailability($position: String, $locationId: String, $_id: String) {
		onUpdatePdfAvailability(position: $position, locationId: $locationId, _id: $_id) {
			_id
			locationId
			position
			pdfAvailability
		}
	}
`;
